/* esm.sh - applesauce-core@5.2.0/helpers/time */
function n(){return Math.round(Date.now()/1e3)}export{n as unixNow};
//# sourceMappingURL=time.mjs.map